import React from 'react';
import { IPricingPlan } from "components/pricing/Plan";
import Plans from "components/pricing/Features/Plans";
import FeaturesCategory from "components/pricing/Features/FeaturesCategory";
import useTrans from "components/hooks/useTrans";
import Text from "components/typography/Text";

type Props = {
    featureCategories: IFeatureCategory[],
    plans: IPricingPlan[],
    pending: boolean,
    title?: string,
    isSalesPage?: boolean
};

export type IFeatureCategory = {
    id: string,
    name: string,
    features: IFeature[],
    page: string
};

export type IFeature = {
    id: string,
    name: string,
    plans: {
        name: string
    }[],
    planValue: {
        plan: {
            name: string
        },
        value: string;
    }[],
    tag: string,
    tooltip: string
};

export default function Features(props: Props) {
    const { featureCategories, title } = props;
    const { t } = useTrans();
    const plans = props.plans.filter((f) => f.name !== "Free");

    return (
        <>
            {title && (
                <div className={"flex justify-center"}>
                    <Text weight={"medium"} color={"text-gray-900"} size={"5xl"} className={"text-center"}>
                        {title}
                    </Text>
                </div>
            )}
            {props.pending ? (
                <>
                    <div className="flex justify-center items-center">
                        Loading...
                    </div>
                </>
            ) : (
                <>
                    <Plans plans={plans} isSalesPage={props.isSalesPage}/>
                    <div className={"mt-5 lg:mt-0"}>
                        {featureCategories.map((category, i) => {
                            const categories = featureCategories.map(fc => fc.name);
                            let isExpended = false;
                            if (props.isSalesPage) {
                                isExpended = i == 0 || i == 1;
                            } else {
                                isExpended = category.name == categories[0];
                            }

                            return (
                                <FeaturesCategory
                                    key={category.id}
                                    features={category.features}
                                    plans={plans}
                                    name={category.name}
                                    categories={featureCategories.map(fc => fc.name)}
                                    isExpended={isExpended}
                                />
                            );
                        })}
                    </div>
                </>
            )}
        </>
    );
}